module.exports = __webpack_public_path__ + "img/indifi.62e57bca.png";